// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"37a7b337","104":"785c64bb","127":"5ab3cdbd","187":"968c1f02","213":"a15592e8","239":"7178ae60","453":"1df0d1a3","455":"b635e233","520":"1339e673","526":"d1bb9bf6","607":"475053c0","633":"e2fbaf34"}[chunkId] + ".chunk.js";
};